<script>
    import {docsStore} from "../core/docs-store.js";
</script>

<style>
    .docs-container {}
    .docs-container .docs-header {}
    .docs-container a {
        color: var(--main-font-color);
        opacity: .9;
        text-decoration: none;
    }
    @media (min-width: 768px) {
        .docs-container li {
            cursor: pointer;
        }
        .docs-container li:hover {
            color: var(--accent-color);
        }
    }
</style>

{#if ($docsStore.length > 0)}
    <div class="docs-container">

        <div class="docs-header">
            Правовая информация
        </div>

        <ul>
            {#each $docsStore as doc}
            <li>
                <a href="{doc.url}" target="_blank">
                    {doc.title} <svg width=".8em" height=".8em" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.47133 8.47134L9.66667 3.27601L10.862 4.47134C10.9552 4.56454 11.074 4.62802 11.2033 4.65373C11.3326 4.67944 11.4666 4.66624 11.5884 4.61579C11.7102 4.56534 11.8143 4.47992 11.8876 4.37031C11.9609 4.2607 12 4.13184 12 4.00001V0.666672L11.9993 0.634672C11.9918 0.463355 11.9182 0.301612 11.7941 0.18331C11.6699 0.0650077 11.5048 -0.000678585 11.3333 5.28681e-06H8C7.86817 3.34364e-05 7.7393 0.039148 7.62969 0.112404C7.52009 0.18566 7.43466 0.289769 7.38421 0.411569C7.33377 0.533369 7.32057 0.667391 7.34628 0.796693C7.37199 0.925995 7.43546 1.04477 7.52867 1.13801L8.724 2.33334L3.52867 7.52867C3.46499 7.59017 3.4142 7.66373 3.37927 7.74507C3.34433 7.8264 3.32594 7.91388 3.32517 8.0024C3.3244 8.09092 3.34127 8.17871 3.37479 8.26064C3.40831 8.34257 3.45781 8.41701 3.5204 8.4796C3.583 8.5422 3.65743 8.5917 3.73936 8.62522C3.82129 8.65874 3.90908 8.67561 3.9976 8.67484C4.08612 8.67407 4.1736 8.65568 4.25494 8.62074C4.33627 8.5858 4.40984 8.53501 4.47133 8.47134ZM0.666667 5.28681e-06C0.489856 5.28681e-06 0.320286 0.0702431 0.195262 0.195267C0.0702379 0.320292 0 0.489861 0 0.666672V10C0 10.5304 0.210714 11.0391 0.585787 11.4142C0.960859 11.7893 1.46957 12 2 12H10C10.5304 12 11.0391 11.7893 11.4142 11.4142C11.7893 11.0391 12 10.5304 12 10V6.66667C12 6.48986 11.9298 6.32029 11.8047 6.19527C11.6797 6.07024 11.5101 6 11.3333 6C11.1565 6 10.987 6.07024 10.8619 6.19527C10.7369 6.32029 10.6667 6.48986 10.6667 6.66667V10C10.6667 10.1768 10.5964 10.3464 10.4714 10.4714C10.3464 10.5964 10.1768 10.6667 10 10.6667H2C1.82319 10.6667 1.65362 10.5964 1.5286 10.4714C1.40357 10.3464 1.33333 10.1768 1.33333 10V1.33334H5.33333C5.51014 1.33334 5.67971 1.2631 5.80474 1.13808C5.92976 1.01305 6 0.843483 6 0.666672C6 0.489861 5.92976 0.320292 5.80474 0.195267C5.67971 0.0702431 5.51014 5.28681e-06 5.33333 5.28681e-06H0.666667Z" fill="currentColor"></path></svg>
                </a>
            </li>
            {/each}
        </ul>
    </div>
{/if}
